module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Author Note")])]), _vm._v(" "), _c('p', {
    staticClass: "fmtni"
  }, [_vm._v("In my last novel, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Once Upon A Scandal,")]), _vm._v(" an excerpt from this book appeared under the title of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Venus Touch.")]), _vm._v(" I wanted you to know that "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Her Secret Affair")]), _vm._v(" is that very same book; only the title has been changed. Enjoy!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269dc1f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/note.vue
// module id = 75
// module chunks = 0